/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { toHeaderCase } from 'js-convert-case';
import { StorageModule } from '@vlinder-web/storage-module-react';

const storageService = StorageModule?.getInstance();
const profileData = storageService.get('myProfile', 'local');
export interface IUserMethods extends IPluginMethodMap {
  getUserProfile(args: any): Promise<any>;
}

export class UserService implements IAgentPlugin {
  readonly methods: IUserMethods;

  constructor() {
    this.methods = {
      getUserProfile: this.getUserProfile.bind(this),
    };
  }

  async getUserProfile(args: any) {
    return {
      userName: this.getUserName({
        firstName: profileData?.name,
        lastName: '',
      }),
      userImage: this.getUserImage({
        firstName: profileData?.name,
        lastName: '',
      }),
    };
  }

  private getUserName(data: any) {
    if (profileData?.name) {
      return `${toHeaderCase(profileData?.name)} ${toHeaderCase(
        data?.lastName ?? ' '
      )}`;
    }
  }

  private getUserImage(data: any) {
    if (profileData?.logo) {
      return profileData?.logo;
    } else {
      return `https://ui-avatars.com/api/?name=${profileData?.name}+${data?.lastName}&background=0D8ABC&color=fff`;
    }
  }
}
